import React, { useEffect, useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import {CHIPS, TEXTAREA} from 'components/cmp_form/cmp_form';
import ICON from 'components/cmp_icon/cmp_icon';

import CMP_NOTE_DELETE from '../cmp_note_delete/cmp_note_delete';


export default function CMP_NOTE_UPDATE({ id, onOpen, onClose, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_data, set_data ] = useState([]);
    const [ var_processing, set_processing ] = useState('inactive');

    const [ var_note_delete_open, set_note_delete_open ] = useState(false);
    const [ var_note_delete_id, set_note_delete_id ] = useState(false);


    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (onOpen && id) {
            get_note();
        }
    }, [ onOpen, id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_note(){

        set_processing('processing');

        try {
            let results = await API_get_note();
            set_data(results === undefined ? {} : results);
            set_processing('inactive');
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }

    async function put_note() {

        set_processing('processing');

        try {
            await API_put_note();
            set_processing('inactive');
            onRefresh();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_note(){
        return API.get('admin-providers', '/get-provider-note/' + id);
    }

    function API_put_note(){
        return API.put('admin-providers', '/put-provider-note', { body: var_data});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_category(event){
        let data = { ...var_data };
        data.category_id = event;
        set_data(data);
    }

    function onChange_input(event){
        let data = {...var_data};
        data[event.target.name] = event.target.value;
        set_data(data);
    }

    function onClick_update(){
        put_note();
    }

    function onClick_cancel(){
        onClose();
    }

    function onClick_delete(){
        set_note_delete_open(true);
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_note_update'>

            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='notes' className='icon' alt='contact icon'/>
                </div>
            </div>

            <div className="modal__header background--blue--500">
                <div className='text--md bold color--white'>Update contact</div>
            </div>

            <div className='modal__content'>

                <CHIPS
                    label={'Category'}
                    onChange={onChange_category}
                    options={[
                        { value: '1578882f-e22f-4035-a161-de7d04928158', text: 'General' },
                        { value: 'd7f2d09f-8f93-4527-864a-10ef3bcf9f98', text: 'Sales' },
                        { value: '720a322f-23f0-45b4-8dcd-94c710167a27', text: 'Customer Support' },
                        { value: '6af01a93-038d-4024-8e3c-032671cb3cbe', text: 'Tech Support' },
                    ]}
                    value={var_data.category_id}
                />

                <TEXTAREA
                    errors={[]}
                    label='Note'
                    name='note'
                    onChange={onChange_input}
                    placeholder=''

                    value={var_data.note || null}
                />

            </div>

            <div className='modal__footer'>
                <Button className='primary' onClick={onClick_update}>Update</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
                <Button className='secondary right' onClick={onClick_delete}>Delete</Button>
            </div>

            <CMP_NOTE_DELETE
                id={id}
                onOpen={var_note_delete_open}
                onClose={() => set_note_delete_open(false)}
                onClose_update={onClose}
                onRefresh={onRefresh}
            />

        </Modal>
    );
}